// @generated by protoc-gen-es v2.6.1 with parameter "target=ts+js"
// @generated from file lease/kiosk/v1/auth.proto (package lease.kiosk.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file lease/kiosk/v1/auth.proto.
 */
export const file_lease_kiosk_v1_auth = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Describes the message lease.kiosk.v1.RequestPinResetRequest.
 * Use `create(RequestPinResetRequestSchema)` to create a new message.
 */
export const RequestPinResetRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 0);

/**
 * Describes the message lease.kiosk.v1.RequestPinResetResponse.
 * Use `create(RequestPinResetResponseSchema)` to create a new message.
 */
export const RequestPinResetResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 1);

/**
 * Describes the message lease.kiosk.v1.KioskLoginRequest.
 * Use `create(KioskLoginRequestSchema)` to create a new message.
 */
export const KioskLoginRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 2);

/**
 * Describes the message lease.kiosk.v1.KioskLoginResponse.
 * Use `create(KioskLoginResponseSchema)` to create a new message.
 */
export const KioskLoginResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 3);

/**
 * Describes the message lease.kiosk.v1.PreKioskLoginRequest.
 * Use `create(PreKioskLoginRequestSchema)` to create a new message.
 */
export const PreKioskLoginRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 4);

/**
 * Describes the message lease.kiosk.v1.PreKioskLoginResponse.
 * Use `create(PreKioskLoginResponseSchema)` to create a new message.
 */
export const PreKioskLoginResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 5);

/**
 * Describes the message lease.kiosk.v1.GetAuthMethodsRequest.
 * Use `create(GetAuthMethodsRequestSchema)` to create a new message.
 */
export const GetAuthMethodsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 6);

/**
 * Describes the message lease.kiosk.v1.GetAuthMethodsResponse.
 * Use `create(GetAuthMethodsResponseSchema)` to create a new message.
 */
export const GetAuthMethodsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 7);

/**
 * Describes the message lease.kiosk.v1.VenueAccessCodeLoginRequest.
 * Use `create(VenueAccessCodeLoginRequestSchema)` to create a new message.
 */
export const VenueAccessCodeLoginRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 8);

/**
 * Describes the message lease.kiosk.v1.VenueAccessCodeLoginResponse.
 * Use `create(VenueAccessCodeLoginResponseSchema)` to create a new message.
 */
export const VenueAccessCodeLoginResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 9);

/**
 * Describes the message lease.kiosk.v1.MobileLoginExpressRequest.
 * Use `create(MobileLoginExpressRequestSchema)` to create a new message.
 */
export const MobileLoginExpressRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 10);

/**
 * Describes the message lease.kiosk.v1.MobileLoginExpressResponse.
 * Use `create(MobileLoginExpressResponseSchema)` to create a new message.
 */
export const MobileLoginExpressResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_auth, 11);

/**
 * Describes the enum lease.kiosk.v1.AuthMethod.
 */
export const AuthMethodSchema = /*@__PURE__*/
  enumDesc(file_lease_kiosk_v1_auth, 0);

/**
 * AuthMethod represents an available authentication method
 *
 * @generated from enum lease.kiosk.v1.AuthMethod
 */
export const AuthMethod = /*@__PURE__*/
  tsEnum(AuthMethodSchema);

/**
 * AuthService is used by UI to get JWT token
 *
 * @generated from service lease.kiosk.v1.AuthService
 */
export const AuthService = /*@__PURE__*/
  serviceDesc(file_lease_kiosk_v1_auth, 0);

